import React, { useState, useEffect } from "react";
import { Table, Input, Typography, Card, Button, Form, message, Space, Segmented, Popconfirm } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import './QueueTable.css'
import axios from 'axios';
import { REGEX, LAMBDAS } from "../../literals";

const { Search } = Input;
const {Title} = Typography;

const parseWaitTime = (WaitTime) => {
    const [hours, minutes, seconds] = WaitTime.split(":").map(Number);
    return (hours * 60) + minutes + (seconds / 60);
};

const getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Search
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ width: 200, marginBottom: 8, display: "block" }}
      />
      <div>
        <button onClick={() => confirm()} style={{ marginRight: 8 }}>Search</button>
        <button onClick={() => { clearFilters(); window.location.reload(); }}>Reset</button>
      </div>
    </div>
  ),
  filterIcon: filtered => <span style={{ color: filtered ? "#1890ff" : undefined }}>🔍</span>,
  onFilter: (value, record) => record[dataIndex].toLowerCase().includes(value.toLowerCase()),
});

const columns = [
  { title: "Contact ID", dataIndex: "ContactID", key: "ContactID", 
    render: ContactID => (<a href={`https://oci-aws-connect-prod.my.connect.aws/contact-trace-records/details/${ContactID}?tz=America/Chicago`} target="_blank" rel="noopener noreferrer">
    {ContactID}</a>), 
    sorter: (a, b) => a.ContactID.localeCompare(b.ContactID),
    ...getColumnSearchProps("ContactID") },
  { title: "Queue Name", dataIndex: "QueueName", key: "QueueName", ...getColumnSearchProps("QueueName") },
  /*{
    title: "Oldest Contact Timestamp",
    dataIndex: "oldestContactTimestamp",
    key: "oldestContactTimestamp",
    sorter: (a, b) => new Date(a.oldestContactTimestamp) - new Date(b.oldestContactTimestamp),
    ...getColumnSearchProps("oldestContactTimestamp")
  },*/
  { title: "Caller's Phone Number", dataIndex: 'PhoneNumber', key: 'PhoneNumber', ...getColumnSearchProps('PhoneNumber')},
  { title: "Position In Queue", dataIndex: "Position", key: "Position", sorter: (a, b) => a.Position - b.Position },
  { title: "Call Wait Time", dataIndex: "WaitTime", key: "WaitTime",
    sorter: (a, b) => {
        const timeA = parseWaitTime(a.WaitTime);
        const timeB = parseWaitTime(b.WaitTime);
        return timeB - timeA;
    },render: time => <span style ={{ color: parseWaitTime(time) > 120 ? "red" : "black"}}>{time}</span>, ...getColumnSearchProps("WaitTime") },
 // { title: "Agent In Contact", dataIndex: "agentInContact", key: "agentInContact", ...getColumnSearchProps("agentInContact") },
  //{ title: "Transferred From", dataIndex: "transferredFrom", key: "transferredFrom", ...getColumnSearchProps("transferredFrom") },
 // { title: "Transfer To", dataIndex: "transferTo", key: "transferTo", ...getColumnSearchProps("transferTo") }
];


const QueueTable = (props) => {
  const agentID = props.agentID;
  const [dataSource, setDataSource] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [isFirstLoad, setIsFirstLoad] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)

  useEffect(() => {
    if (!isFirstLoad || isRefreshing) {
      console.log("AGENTID: ", agentID)
      axios({
        method: 'POST',
        baseURL: LAMBDAS.CURRENT_CALLS,
        headers: { authorizationToken: agentID },
        data: {},
      }).then((response) => {
        console.log("RESPONSE DATA CALLERS: ", response.data.body)

        setDataSource(response.data.body)

      }).catch((error) => {
        console.log(error);
      });
      setIsFirstLoad(true)
      setIsRefreshing(false)
    }

  }, [isFirstLoad, isRefreshing])

  useEffect(() => {
    // Set up an interval to refresh every 1 minute (60,000 ms)
    const intervalId = setInterval(() => {
      setIsRefreshing(true)
    }, 60000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={{ padding: 24, backgroundColor: '#f0f2f5'}}>
      {/* <Title level={2} className="header-title"> Real-Time Callers Data</Title> */}
      <Card title="Real-Time Callers Data" hoverable>
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey="ContactID"
      pagination={{
        pageSize: 5,
        current: currentPage,
        showSizeChanger: false,
        onChange: page => setCurrentPage(page)
      }}
    />
    <Form.Item>
        <Space>
          <Button htmlType="button" onClick={() => { setIsRefreshing(true) }}>
            Refresh Caller Data
          </Button>
        </Space>
      </Form.Item>
    </Card>
    </div>
  );
};

export default QueueTable;

